export const YOUTUBE_REG_EXPS = [
  /^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/,
  /^(?:m\.)?youtube\.com\/v\/([\w-А]+)/,
  /^youtube\.com\/embed\/([\w-]+)/,
  /^youtu\.be\/([\w-]+)/,
]
export const YOUTUBE_REG_EXP =
  /(?:https?:\/\/)?((?:www|m)\.)?youtu(?:\.be\/|be.com\/\S*(?:watch|embed)(?:(?:(?=\/[-a-zA-Z0-9_]{11,}(?!\S))\/)|(?:\S*v=|v\/)))([-a-zA-Z0-9_]{11,})/

export const SHARE_POINT_REG_EXP = /https:\/\/(?:hp|hp-my)\.sharepoint\.com(\S*)/
export const MICROSOFT_STREAM_REG_EXP = /https:\/\/web\.microsoftstream\.com(\S*)/
export const BRIGHTCOVE_REG_EXP = /https:\/\/players\.brightcove\.net(\S*)/
